<template>
  <nav
    v-clickaway="
      () => {
        isMenuOpen = false;
      }
    "
    class="sticky top-0 z-50 bg-gray-800 dark:bg-gray-950 border-b border-gray-800"
  >
    <div class="px-3 md:px-0 mx-auto max-w-7xl">
      <div class="flex justify-between items-center h-20">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <a href="/">
              <img
                class="h-11"
                src="../assets/compass-logo-2.svg"
                alt="Workflow"
              >
            </a>
          </div>
        </div>
        <div
          v-if="isMinimumLgScreen"
          class="-ml-10"
        >
          <div class=" flex items-baseline space-x-4">
            <div
              v-for="(item, index) in links"
              :key="index"
            >
              <router-link
                v-if="!Array.isArray(item.children)"
                v-slot="{ href, navigate, isActive }"
                :exact="item.exact"
                :to="item.to"
              >
                <a
                  class="py-2.5 px-4 font-medium text-white text-opacity-80 rounded-lg transition-colors"
                  :class="
                    isActive
                      ? 'bg-gray-900 dark:bg-indigo-500 dark:bg-opacity-15 text-indigo-500 text-opacity-100'
                      : 'hover:text-indigo-500'
                  "
                  :href="href"
                  @click="navigate"
                >
                  {{ item.title }}
                </a>
              </router-link>
              <ui-dropdown v-if="Array.isArray(item.children)">
                <template #toggle="{ toggle, isVisible }">
                  <a
                    class="py-2.5 px-4 font-medium text-white text-opacity-80 rounded-lg transition-colors cursor-pointer"
                    :class="
                      isVisible
                        ? 'bg-gray-900 dark:bg-indigo-500 dark:bg-opacity-15 text-indigo-500 text-opacity-100'
                        : 'hover:bg-gray-800 hover:text-opacity-100'
                    "
                    @click="toggle"
                  >
                    {{ item.title }}
                  </a>
                </template>
                <ui-dropdown-item
                  v-for="(child, childIndex) in item.children"
                  :key="childIndex"
                  tag="router-link"
                  :to="child.to"
                >
                  {{ child.title }}
                </ui-dropdown-item>
              </ui-dropdown>
            </div>
          </div>
        </div>

        <div v-if="isMinimumLgScreen">
          <div class="flex items-center space-x-6">
            <universal-search @select-result="openResult">
              <template #search-field="{ doSearch, search, show }">
                <div class="flex relative items-center">
                  <span
                    class="absolute ml-3 text-sm text-gray-500"
                  ><i class="far fa-search" /></span>
                  <input
                    id="main-search-input"
                    v-model="search.term"
                    class="
                      py-2.5
                      pr-4
                      pl-9
                      w-64
                      text-sm
                      font-medium
                      placeholder-gray-400
                      focus:placeholder-gray-400
                      text-gray-100
                      bg-gray-800
                      hover:bg-gray-700
                      focus:bg-gray-700
                      dark:bg-opacity-75
                      rounded-full
                      border
                      focus:border
                      border-none
                      focus:ring-2
                      focus:ring-indigo-500
                      focus:ring-offset-2
                      ring-offset-black
                      focus:outline-none
                    "
                    placeholder="Search collections and wallets"
                    @focus="show"
                    @keyup.enter="doSearch($event.target.value)"
                  >
                </div>
              </template>
            </universal-search>

            <user-profile>
              <template #authenticated="{ wallet }">
                <ui-dropdown
                  class="-ml-1"
                  right
                >
                  <template #toggle="{ toggle }">
                    <button
                      type="button"
                      class="
                        flex
                        items-center
                        max-w-xs
                        bg-gray-800
                        rounded-full
                        focus:ring-2
                        focus:ring-indigo-500
                        focus:ring-offset-2
                        focus:ring-offset-gray-800
                        focus:outline-none
                        text-sm text-white
                      "
                      @click="toggle"
                    >
                      <wallet-profile
                        no-overlay
                        :wallet="wallet"
                        only-pic
                        :pic-size="9"
                      />
                    </button>
                  </template>
                  <ui-dropdown-form
                    v-if="premiumExpiresAt"
                    class="py-2"
                  >
                    <div
                      class="py-1 px-2 text-xs font-medium text-indigo-900 bg-indigo-500 rounded cursor-pointer"
                      @click="eventBus.$emit('auth:showPremiumModal', 'period selector')"
                    >
                      Premium until {{ moment(premiumExpiresAt).format("l") }}
                    </div>
                  </ui-dropdown-form>
                  <hr
                    v-if="premiumExpiresAt"
                    class="my-2 dark:border-gray-700"
                  >
                  <ui-dropdown-item
                    v-for="(item, index) in user.wallets"
                    :key="index"
                    tag="router-link"
                    :to="{
                      name: 'Wallet.Show',
                      params: { address: item.id },
                    }"
                  >
                    <wallet-profile
                      no-overlay
                      no-link
                      :wallet="item"
                      :pic-size="6"
                    />
                  </ui-dropdown-item>
                  <hr class="my-2 dark:border-gray-700">
                  <ui-dropdown-item
                    tag="router-link"
                    :to="{
                      name: 'Settings',
                    }"
                  >
                    <div class="flex content-center items-center">
                      <div class="w-6">
                        <i class="text-md fas fa-cog" />
                      </div>
                      <div>Settings</div>
                    </div>
                  </ui-dropdown-item>
                  <ui-dropdown-item
                    v-if="!user.isDiscordLinked && showDiscordLink"
                    tag="a"
                    href="https://discord.com/api/oauth2/authorize?client_id=901060393194115083&redirect_uri=https%3A%2F%2Fcompass.art%2Fhooks%2Fdiscord&response_type=code&scope=guilds.join%20identify"
                  >
                    <div class="flex content-center items-center">
                      <div class="w-6">
                        <i class="-ml-0.5 text-md fab fa-discord" />
                      </div>
                      <div>Get Discord Role</div>
                    </div>
                  </ui-dropdown-item>
                  <ui-dropdown-item
                    tag="router-link"
                    :to="{
                      path: '/'
                    }"
                    @click="$store.dispatch('auth/logout')"
                  >
                    <div class="flex content-center items-center">
                      <div class="w-6">
                        <i class="text-md fas fa-sign-out" />
                      </div>
                      <div>Sign out</div>
                    </div>
                  </ui-dropdown-item>
                </ui-dropdown>
              </template>
            </user-profile>
          </div>
        </div>

        <div
          v-if="!isMinimumLgScreen"
          class="flex items-center -mr-2 space-x-3"
        >
          <button
            type="button"
            class="
              inline-flex
              justify-center
              items-center
              p-2
              text-gray-400
              bg-gray-900
              hover:text-white hover:bg-gray-800
              rounded-md
              focus:ring-2
              focus:ring-indigo-500
              focus:ring-offset-2
              focus:ring-offset-black
              focus:outline-none
            "
            aria-controls="mobile-menu"
            aria-expanded="false"
            @click="toggleMenu"
          >
            <span class="sr-only">Open main menu</span>
            <!--
              Heroicon name: outline/menu

              Menu open: "hidden", Menu closed: "block"
            -->
            <svg
              :class="isMenuOpen ? 'hidden' : 'block'"
              class="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!--
              Heroicon name: outline/x

              Menu open: "block", Menu closed: "hidden"
            -->
            <svg
              :class="isMenuOpen ? 'block' : 'hidden'"
              class="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile menu, show/hide based on menu state. -->
    <div
      v-if="isMenuOpen && !isMinimumLgScreen"
      id="mobile-menu"
      class="absolute w-full bg-gray-950 dark:bg-gray-950"
      @click="isMenuOpen = false"
    >
      <div class="px-2 sm:px-3 pt-2 pb-3 space-y-1">
        <router-link
          v-for="(item, index) in links"
          :key="index"
          v-slot="{ href, navigate, isActive }"
          :exact="item.exact"
          :to="Array.isArray(item.children) ? item.children[0].to : item.to"
        >
          <a
            class="block py-2 px-3 text-base font-medium rounded-md"
            :class="
              isActive
                ? 'bg-gray-900 text-white'
                : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            "
            :href="href"
            @click="navigate"
          >
            {{ item.title }}
          </a>
        </router-link>
      </div>
      <div
        class="py-3 px-5 border-t border-gray-800"
        @click.stop
      >
        <universal-search @select-result="openResult">
          <template #search-field="{ doSearch, search, show }">
            <div class="flex relative items-center">
              <span
                class="absolute ml-3 text-sm text-gray-500"
              ><i class="far fa-search" /></span>
              <input
                v-model="search.term"
                class="
                  py-2
                  px-4
                  pl-9
                  w-64
                  text-sm
                  placeholder-gray-300
                  focus:placeholder-gray-400
                  text-gray-100
                  focus:text-gray-900
                  bg-gray-900
                  hover:bg-gray-600
                  focus:bg-white
                  rounded-lg
                  border
                  focus:border
                  border-none
                  focus:ring-2
                  focus:ring-indigo-500
                  focus:ring-offset-2
                  focus:outline-none
                "
                placeholder="Search collections and wallets"
                @focus="show"
                @keyup.enter="doSearch($event.target.value)"
              >
            </div>
          </template>
        </universal-search>
      </div>
      <div
        class="pt-3 pb-3 border-t border-gray-800"
        @click.stop
      >
        <div class="flex justify-between items-center px-5">
          <user-profile class="w-full">
            <template #authenticated="{ wallet }">
              <div class="flex justify-between items-center">
                <div
                  class="flex-shrink-0"
                  @click="isMenuOpen = false"
                >
                  <ui-dropdown-item
                    tag="router-link"
                    class="px-0 pl-1"
                    :to="{
                      name: 'Wallet.Show',
                      params: { address: wallet.id },
                    }"
                  >
                    <wallet-profile
                      class="inline"
                      no-link
                      no-overlay
                      :pic-size="8"
                      :wallet="wallet"
                    />
                  </ui-dropdown-item>
                </div>

                <div
                  class="flex justify-end w-full"
                  @click="isMenuOpen = false"
                >
                  <ui-dropdown-item
                    tag="router-link"
                    :to="{
                      name: 'Settings',
                    }"
                  >
                    <i class="text-lg fas fa-cog" />
                  </ui-dropdown-item>
                  <ui-dropdown-item
                    v-if="!user.isDiscordLinked && showDiscordLink"
                    tag="a"
                    href="https://discord.com/api/oauth2/authorize?client_id=901060393194115083&redirect_uri=https%3A%2F%2Fcompass.art%2Fhooks%2Fdiscord&response_type=code&scope=guilds.join%20identify"
                  >
                    <i class="text-lg fab fa-discord" />
                  </ui-dropdown-item>
                  <ui-dropdown-item
                    tag="router-link"
                    :to="{
                      path: '/'
                    }"
                    @click="$store.dispatch('auth/logout')"
                  >
                    <i class="text-lg fas fa-sign-out" />
                  </ui-dropdown-item>
                </div>
              </div>
            </template>
          </user-profile>
          <!--          <button type="button" class="ml-auto bg-gray-800 flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">-->
          <!--            <span class="sr-only">View notifications</span>-->
          <!--            &lt;!&ndash; Heroicon name: outline/bell &ndash;&gt;-->
          <!--            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
          <!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />-->
          <!--            </svg>-->
          <!--          </button>-->
        </div>
        <!--        <div class="mt-3 px-2 space-y-1">-->
        <!--          <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700">Your Profile</a>-->

        <!--          <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700">Settings</a>-->

        <!--          <a href="#" class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700">Sign out</a>-->
        <!--        </div>-->
      </div>
    </div>

    <!-- <div class="bg-blue-400 text-white" v-if="isBannerVisible">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span class="font-medium"></span>
        <div
          class="
            py-2
            text-sm
            space-y-3
            md:space-y-0 md:flex md:justify-between md:items-center
          "
        >
          <div>
            Compass.art is in beta. If you have any questions or suggestions,
            reach out to us on
            <ui-link
              class="underline"
              href="https://discord.gg/pzsMNaKjfN"
              target="_blank"
              >Discord</ui-link
            >.
          </div>
          <div>
            <ui-button variant="blue" size="xs" @click="dismissBanner"
              >Dismiss</ui-button
            >
          </div>
        </div>
      </div>
    </div> -->
  </nav>
</template>

<script>
import { defineComponent } from "vue";
import { useDevice } from "@/composition/device-detector";
import UserProfile from "@/components/UserProfile";
import WalletProfile from "@/components/wallets/WalletProfile";
import UniversalSearch from "@/components/universal-search/UniversalSearch";
import UiLink from "@/components/ui/UiLink";
import UiButton from "@/components/ui/UiButton";
import DarkModeToggle from "./DarkModeToggle.vue";
import GasTracker from "./GasTracker.vue";
import UiDropdown from './ui/UiDropdown.vue';
import UiDropdownItem from './ui/UiDropdownItem.vue';
import UiDropdownForm from './ui/UiDropdownForm.vue';
import moment from "moment-timezone";
import eventBus from "@/utils/event-bus";

export default defineComponent({
  name: "AppHeader",
  components: {
    UiButton,
    UiLink,
    UniversalSearch,
    WalletProfile,
    UserProfile,
    UiDropdownItem,
    UiDropdown,
    DarkModeToggle,
    GasTracker,
    UiDropdownForm,
  },
  props: ["links"],
  setup() {
    const { isMinimumLgScreen } = useDevice();

    return {
      moment,
      eventBus,
      isMinimumLgScreen,
    }
  },
  data() {
    return {
      isMenuOpen: false,
      isBannerVisible: localStorage.getItem("alpha-banner-dismissed") === null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
    user() {
      return this.$store.state.auth.user;
    },
    premiumExpiresAt() {
      return this.user.premiumExpiresAt;
    },
    showDiscordLink() {
      return this.isLoggedIn
        && this.user.passBalance > 0
        && !this.user.isDiscordLinked;
    }
  },
  mounted() {
    document.addEventListener('keyup', event => {
      if (event.key !== '/') {
        return;
      }

      document.getElementById('main-search-input').focus();
    });
  },
  methods: {
    openResult({type, data}) {

      if (type === 'collection') {
        this.$router.push({name: 'Collections.Show', params: { contractAddress: data.id }})
      }

      if (type === 'wallet') {
        this.$router.push({name: 'Wallet.Show', params: { address: data.id }})
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    dismissBanner() {
      this.isBannerVisible = false;
      localStorage.setItem("alpha-banner-dismissed", Date.now());
    },
    linkDiscord() {
      window.location.href = process.env.VUE_APP_DISCORD_AUTH_REDIRECT_URL;
    }
  }
});
</script>

<style scoped>
</style>
